import { render, staticRenderFns } from "./FeeTypeForm.vue?vue&type=template&id=73c797b4&scoped=true"
import script from "./FeeTypeForm.vue?vue&type=script&lang=js"
export * from "./FeeTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c797b4",
  null
  
)

export default component.exports